import { z } from "zod";
import {
  ASSIGN_TO,
  CATEGORY,
  DESCRIPTION,
  DUE_DATE,
  NAME,
  NOTES,
  PRIORITY,
  ROLE,
  SCHOOL,
  TASK_ATTACHMENT,
  TASK_STATUS,
  TASKS,
  TERM,
} from "../consts";

export const schema = z.object({
  [TASKS]: z
    .object({
      [NAME]: z.string().min(1, "this field is required"),
      [CATEGORY]: z.string().min(1, "this field is required"),
      [PRIORITY]: z.string().min(1, "this field is required"),
      [TERM]: z.string().min(1, "this field is required"),
      [DUE_DATE]: z.string().min(1, "this field is required"),
      [TASK_STATUS]: z.string().min(1, "this field is required"),
      [TASK_ATTACHMENT]: z.string().optional(),
      [SCHOOL]: z.string().min(1, "this field is required"),
      [ROLE]: z.string().min(1, "this field is required"),
      [ASSIGN_TO]: z.string().min(1, "this field is required"),
    })
    .array(),
  [DESCRIPTION]: z.string().optional(),
  [NOTES]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
